export const CARD_DESCRIPTION_CLASS =
    "  px-3 text-xl md:text-[32px] md:leading-9 font-normal italic font-libre text-Heading_Black ";
